module.exports = __webpack_public_path__ + "09_mole.b846229a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/09_mole.png
// module id = dx7U
// module chunks = 0